import { PRINTER_API } from '../constants/api'
import { PAGINATION_ALL_ITEMS_SIZE } from '../constants/pagination'
import { deleteApi, getApi, patchApi, postApi } from '../utils/api'

export function getPrinters() {
  return getApi({
    endpoint: PRINTER_API,
    params: { page_size: PAGINATION_ALL_ITEMS_SIZE },
  })
}

export function createPrinter(data) {
  return postApi({ data, endpoint: PRINTER_API })
}

export function updatePrinter({ data, id }) {
  return patchApi({ data, endpoint: `${PRINTER_API}${id}/` })
}

export function deletePrinter(id) {
  return deleteApi({ endpoint: `${PRINTER_API}${id}/` })
}
